// extracted by mini-css-extract-plugin
export default {"__overlay":"styles___overlay__xwCV2","__modal":"styles___modal__u1w30","__head":"styles___head__ckdt5","__container":"styles___container__DYzDH"};